import styled from 'styled-components';
import { Close } from '@mui/icons-material';
import { Snackbar as SnackbarBase, Typography } from '@mui/material';
import { Flex } from '../Flex';
import IconButton from '../IconButton';

export type SnackbarVariant = 'success' | 'error';

export type SnackbarAction = { text: string; cb: () => void };

const SnackbarStyled = styled(SnackbarBase)<{ $variant?: SnackbarVariant }>`
  & .MuiSnackbarContent-message {
    color: ${({ $variant, theme }) =>
      $variant === 'success'
        ? theme.palette.common.green100
        : $variant === 'error'
        ? theme.palette.common.red100
        : 'auto'};
    max-width: 306px;
  }
`;

const ActionButton = styled(Typography)`
  cursor: pointer;
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  color: ${({ theme }) => theme.palette.common.white};
`;

type Props = {
  open: boolean;
  variant?: SnackbarVariant;
  message?: string;
  duration?: number;
  actions?: SnackbarAction[];
  autoHide?: boolean;
  onClose: () => void;
};

const Snackbar = ({
  open,
  variant,
  message,
  duration,
  actions,
  autoHide = true,
  onClose,
}: Props) => (
  <SnackbarStyled
    $variant={variant}
    open={open}
    autoHideDuration={autoHide ? duration ?? 6000 : null}
    message={message}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    onClose={onClose}
    ClickAwayListenerProps={{ mouseEvent: false }}
    action={
      <Flex sx={{ pl: 1, gap: 3, alignItems: 'center' }}>
        {actions?.map((action) => (
          <ActionButton key={action.text} onClick={() => action.cb()}>
            {action.text}
          </ActionButton>
        ))}
        <IconButton sx={{ color: 'inherit' }} onClick={onClose}>
          <Close />
        </IconButton>
      </Flex>
    }
  />
);

export default Snackbar;
